import { Link } from "react-router-dom";
import { Building2, Mail, MapPin, BookOpen, MessageCircle } from "lucide-react";

export function FooterSEO() {
  return (
    <footer className="bg-slate-950 text-slate-200 pt-16 pb-8 border-t border-slate-800">
      {/* Hidden Internal Spiritual Note */}
      <span className="sr-only" data-blessing="Hasbunallah wa ni'mal wakeel">Hasbünallahü ve ni'me'l-vekîl</span>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand Info */}
          <div className="lg:col-span-2 space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center text-primary-foreground shadow-md">
                <Building2 className="h-6 w-6" />
              </div>
              <div>
                <span className="font-extrabold text-xl tracking-tight text-white block leading-none">
                  CORNER
                </span>
                <span className="text-[10px] font-semibold tracking-widest text-slate-400 uppercase block mt-0.5">
                  GAYRİMENKUL ADANA
                </span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              Adana Seyhan, Çukurova ve Gürselpaşa bölgesinde satılık ve kiralık daire, villa, arsa ve işyeri portföyleri sunan, profesyonel gayrimenkul yatırım danışmanlığı firması.
            </p>

            <div className="space-y-2 text-sm text-slate-300 pt-2">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-primary shrink-0 mt-1" />
                <span>Gürselpaşa Mah. Aliya İzzetbegoviç Bulv. Seyhan / Adana</span>
              </div>
              <div className="flex items-center gap-2">
                <a href="https://wa.me/905335487801" target="_blank" rel="noreferrer" className="text-green-400 hover:text-green-300 transition-colors font-medium flex items-center gap-1 text-xs">
                  <MessageCircle className="h-3.5 w-3.5" /> WhatsApp
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary shrink-0" />
                <a href="mailto:info@cornergayrimenkul.com.tr" className="hover:text-white transition-colors">info@cornergayrimenkul.com.tr</a>
              </div>
            </div>
          </div>

          {/* Popüler Bölgeler & İlanlar */}
          <div className="space-y-3">
            <h4 className="font-bold text-white text-base tracking-wide border-b border-slate-800 pb-2">
              Popüler Portföyler & Bölgeler
            </h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/satilik" className="hover:text-primary transition-colors">Adana Satılık Daireler</Link></li>
              <li><Link to="/kiralik" className="hover:text-primary transition-colors">Adana Kiralık Daireler</Link></li>
              <li><Link to="/adana/seyhan/gurselpasa" className="hover:text-primary font-medium text-slate-200 transition-colors">⭐ Gürselpaşa Satılık Daire</Link></li>
              <li><Link to="/adana/cukurova/guzelyali" className="hover:text-primary font-medium text-slate-200 transition-colors">⭐ Güzelyalı Satılık Evler</Link></li>
              <li><Link to="/luks-projeler" className="hover:text-primary transition-colors">Lüks Rezidans & Villalar</Link></li>
              <li><Link to="/ticari-gayrimenkul" className="hover:text-primary transition-colors">Satılık Dükkan & Mağaza</Link></li>
              <li><Link to="/arsa" className="hover:text-primary transition-colors">Kabasakal & Çukurova Arsa</Link></li>
            </ul>
          </div>

          {/* Emlak Rehberleri & Blog */}
          <div className="space-y-3">
            <h4 className="font-bold text-white text-base tracking-wide border-b border-slate-800 pb-2 flex items-center gap-2">
              <BookOpen className="h-4 w-4 text-primary" /> Emlak Rehberleri (20)
            </h4>
            <ul className="space-y-2 text-xs text-slate-400">
              <li><Link to="/blog" className="hover:text-primary font-bold text-slate-200 transition-colors">📚 Tüm Blog & Rehberler (20)</Link></li>
              <li><Link to="/blog/gurselpasada-ev-alinir-mi-gurselpasa-gayrimenkul-rehberi" className="hover:text-primary transition-colors line-clamp-1">Gürselpaşa Emlak Rehberi</Link></li>
              <li><Link to="/blog/adanada-ev-alirken-nelere-dikkat-edilmeli" className="hover:text-primary transition-colors line-clamp-1">Ev Alırken 7 Altın Kural</Link></li>
              <li><Link to="/blog/cukurova-mi-seyhan-mi-adanada-ev-almak-icin-hangi-ilce" className="hover:text-primary transition-colors line-clamp-1">Çukurova mı Seyhan mı?</Link></li>
              <li><Link to="/blog/kabasakal-ve-cukurova-arsa-yatirimi-rehberi" className="hover:text-primary transition-colors line-clamp-1">Kabasakal Arsa Rehberi</Link></li>
              <li><Link to="/blog/2026-adana-konut-amortisman-sureleri-ve-kira-getirisi-analizi" className="hover:text-primary transition-colors line-clamp-1">2026 Amortisman Süreleri</Link></li>
              <li><Link to="/blog/tapu-devir-islemlerinde-gerekli-belgeler-ve-tapu-harci-hesaplama" className="hover:text-primary transition-colors line-clamp-1">Tapu Harcı Hesaplama</Link></li>
            </ul>
          </div>

          {/* Kurumsal & Hizmetler */}
          <div className="space-y-3">
            <h4 className="font-bold text-white text-base tracking-wide border-b border-slate-800 pb-2">
              Kurumsal & Danışmanlık
            </h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/adana-gayrimenkul-rehberi" className="hover:text-primary font-semibold text-white transition-colors">Adana Gayrimenkul Rehberi</Link></li>
              <li><Link to="/corner-cevapliyor" className="hover:text-primary text-amber-400 font-semibold transition-colors">Corner Cevaplıyor (AI Q&A)</Link></li>
              <li><Link to="/karsilastirma" className="hover:text-primary transition-colors">Bölge Karşılaştırmaları</Link></li>
              <li><Link to="/gayrimenkulumu-sat" className="hover:text-primary transition-colors">Gayrimenkulünü Sat</Link></li>
              <li><Link to="/degerleme" className="hover:text-primary transition-colors">Ücretsiz Ev Değerleme</Link></li>
              <li><Link to="/tadilat-dekorasyon" className="hover:text-primary transition-colors">Tadilat & Dekorasyon</Link></li>
              <li><Link to="/hakkimizda" className="hover:text-primary transition-colors">Hakkımızda & Ekibimiz</Link></li>
              <li><Link to="/iletisim" className="hover:text-primary transition-colors">İletişim & Lokasyon</Link></li>
              <li><Link to="/dashboard" className="hover:text-primary transition-colors">Yönetici girişi</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 border-t border-slate-800/80 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500 gap-4">
          <p>© {new Date().getFullYear()} Corner Gayrimenkul - Tüm Hakları Saklıdır. Adana Güvenilir Emlak & Gayrimenkul Danışmanlığı.</p>
          <div className="flex gap-6">
            <Link to="/kira-sozlesmesi" className="hover:text-slate-400">Kira sözleşmesi hazırlama</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
